import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventTickerItem } from './event-ticker.types';

@Injectable({
    providedIn: 'root'
})
export class EventTickerService {
    private _events: BehaviorSubject<EventTickerItem[]> = new BehaviorSubject<EventTickerItem[]>([]);

    /**
     * Getter for events
     */
    get events$(): Observable<EventTickerItem[]> {
        return this._events.asObservable();
    }

    /**
     * Set events to be displayed in the event ticker
     *
     * @param events
     */
    setEvents(events: EventTickerItem[]): void {
        this._events.next(events || []);
    }

    /**
     * Clear all events
     */
    clearEvents(): void {
        this._events.next([]);
    }
}
